export const footer = {
  "description": "Η πλατφόρμα ανταλλαγής κατοικιών μεταξύ ιδιοκτητών Airbnb. Ταξιδέψτε δωρεάν σε όλο τον κόσμο.",
  "company": "Εταιρεία",
  "about": "Σχετικά",
  "howItWorks": "Πώς λειτουργεί",
  "blog": "Ιστολόγιο",
  "careers": "Καριέρα",
  "support": "Υποστήριξη",
  "help": "Κέντρο βοήθειας",
  "contact": "Επικοινωνία",
  "terms": "Όροι χρήσης",
  "privacy": "Απόρρητο",
  "community": "Κοινότητα",
  "members": "Μέλη",
  "destinations": "Προορισμοί",
  "events": "Εκδηλώσεις",
  "newsletter": "Ενημερωτικό δελτίο",
  "newsletterText": "Λάβετε τις τελευταίες προσφορές και νέα μας",
  "emailPlaceholder": "Το email σας",
  "newsletterSuccess": "Η εγγραφή ήταν επιτυχής!",
  "newsletterError": "Παρουσιάστηκε σφάλμα.",
  "newsletterInvalid": "Μη έγκυρο email.",
  "subscribe": "Εγγραφή",
  "rights": "Με επιφύλαξη παντός δικαιώματος",
  "madeWith": "Φτιαγμένο με",
  "by": "από την ομάδα DONKEY TRAVEL"
};
